import React from 'react';
import { FadeIn } from './FadeIn';
import { WhatsAppButton } from './WhatsAppButton';
export function FinalCTA() {
  return <section className="py-32 md:py-48 px-6 md:px-12 bg-charcoal relative overflow-hidden" data-id="element-63">
      {/* Subtle background image for atmosphere */}
      <div className="absolute inset-0 z-0 opacity-25" data-id="element-64">
        <img src="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" alt="" className="w-full h-full object-cover" data-id="element-65" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/80 to-charcoal" data-id="element-66" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-67">
        <FadeIn data-id="element-68">
          <h2 className="font-serif text-5xl md:text-6xl text-cream mb-8 leading-tight" data-id="element-69">
            Ready to come reset?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-70">
          <p className="text-xl text-sand/85 font-light leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-71">
            Message Zev to ask about sauna nights, private retreats, workshops,
            or staying on the land.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4" data-id="element-72">
          <WhatsAppButton label="Message Zev on WhatsApp" data-id="element-73" />
          <a href="#stay" className="inline-flex items-center justify-center px-7 py-4 bg-transparent border border-cream/30 text-cream rounded-sm font-medium tracking-wide hover:bg-cream/10 transition-colors" data-id="element-74">
            Stay at the Retreat
          </a>
        </FadeIn>
      </div>
    </section>;
}